import React from "react";
import BoxFrame from "../BoxFrame";
import { FrameTitle, FrameContent } from "../style";
import { Wrapper } from "./style";
import { useTranslation } from "react-i18next";

const TransactionReversibility = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <BoxFrame alignImage="right" dataImage="./images/Frame48095730.svg">
        <FrameTitle>{t("transactionReversibility.title")}</FrameTitle>
        <FrameContent>
          <p>{t("transactionReversibility.desc1")}</p>
          <p>{t("transactionReversibility.desc2")}</p>
        </FrameContent>
      </BoxFrame>
    </Wrapper>
  );
};

export default TransactionReversibility;
